<div class="flex flex-col gap-1">
  <div class="flex items-center gap-2">
    <input
      vsInput
      [id]="checkboxId"
      type="checkbox"
      [appearance]="property.config.format ?? 'checkbox'"
      [formControl]="formControl"
      [required]="required"
    />
    <label vsCheckboxLabel [attr.for]="checkboxId">{{ displayLabel || property.name }}</label>
  </div>
  <span *ngIf="helpText" class="text-gray-600 text-sm ml-6">{{ helpText }}</span>
  <span class="text-danger" *ngIf="formControl.touched && formControl.hasError('requiredTrue')">
    {{ displayLabel || property.name }} must be true
  </span>
  <span class="text-danger" *ngIf="formControl.touched && formControl.hasError('requiredFalse')">
    {{ displayLabel || property.name }} must be false
  </span>
</div>
